import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/super-admin',
        component: () => import('@/layouts/ModuleLayout.vue'),
        meta: {
        },
        children: [
            {
                path: 'organizations',
                name: 'OrganizationList',
                component: () => import('./views/OrganizationList.vue'),
            },
            {
                path: 'organizations/create',
                name: 'OrganizationCreate',
                component: () => import('./views/OrganizationCreate.vue'),
            },
            {
                path: 'organizations/:id',
                name: 'OrganizationDetail',
                component: () => import('./views/OrganizationDetail.vue'),
                props: true,
            },
        ],
    },
]

export default routes
